/**
 * Bản tin MQTT Id 46 — khóa / hủy khóa thao tác người dùng (LockScreen).
 * Enable: true = khóa, false = hủy khóa.
 */
export interface LockScreenMessage {
  Id: number;
  Time: number;
  Sender: string;
  Enable: boolean;
}

export const MQTT_MESSAGE_LOCK_SCREEN = 46 as const;

export const isLockScreenPayload = (
  data: unknown
): data is LockScreenMessage => {
  if (data === null || typeof data !== "object") return false;
  const d = data as Record<string, unknown>;
  return (
    d.Id === MQTT_MESSAGE_LOCK_SCREEN &&
    typeof d.Enable === "boolean"
  );
};
